export const iconFontAwesomeSecurityShieldHeart = (
	<i className="fa-solid fa-shield-heart"></i>
);
